import { render } from "./UP_LookingFor_Elem.vue?vue&type=template&id=8e5ec8dc"
import script from "./UP_LookingFor_Elem.vue?vue&type=script&lang=js"
export * from "./UP_LookingFor_Elem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__